'use client';

import { useEffect } from 'react';
import { applyUserPanelTheme, normalizePanelTheme } from '@/lib/panelTheme';

/**
 * Applies panel theme from localStorage before/without PanelLayout (e.g. auth pages).
 * Logged-in user theme is applied from JWT in UserAuthContext.
 */
export default function PanelThemeSync() {
  useEffect(() => {
    try {
      applyUserPanelTheme(normalizePanelTheme(localStorage.getItem('panel-theme')));
    } catch {
      applyUserPanelTheme('dark');
    }
  }, []);
  return null;
}
